import React from "react"

import { buildQuery, compress, useQuery } from "micro-graphql-react"
import Select from "react-select"

import { studentClient } from "src/graphql-config"
import ordered from "src/ordered"

import WithLoadingIndicator from "components/WithLoadingIndicator"

const Subjects = props => {
  const loadingState = useQuery(
    buildQuery(subjectsQuery, {}, { client: studentClient })
  )

  return (
    <WithLoadingIndicator
      loadingState={loadingState}
      error="An error occurred while loading your subjects"
    >
      {({ data }) => (
        <Select
          options={ordered(data.subjects, "name")}
          onChange={props.onChange}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
        />
      )}
    </WithLoadingIndicator>
  )
}

const subjectsQuery = compress`
  query {
    subjects {
      id
      name
    }
  }
`

export default Subjects
